<template>
  <div class="group-wrap">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree
          @changeCompany="changeCompany"
          :data="viewTreeData"
          @getTreeData="getTreeData"
          @tabTreeDefault="tabTreeDefault"
          @tabTreeClick="tabTreeClick"
        ></tab-tree>
      </div>
      <div class="content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="search-box box">
          <time-search
            ref="timeSearch"
            :control="{ data: timeData }"
            @timeControlChange="timeControlChange"
            @timeControlClick="TimeControlClick"
          >
          </time-search>
        </div>
        <div class="chart-content">
          <el-row :gutter="14">
            <el-col :span="16">
              <div class="chart-box">
                <div class="title">分项用能趋势图</div>
                <div class="useTop">总用电量 : {{ useEle }} (kWh)</div>
                <div class="chart" id="lineChart" v-resize="resize"></div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="chart-box">
                <div class="title">分项用能占比</div>
                <div class="chart" id="pieChart" v-resize="resize"></div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="chart-box table-content">
          <div class="title">用电整体情况</div>
          <div class="chart">
            <nk-table :columns="columns" :data="tableData"></nk-table>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>

<script>
  import TabTree from "@/components/common/TabTree.vue"
  import { itemColor } from "@/config/data.js"
  import BtnShow from "@/components/common/BtnShow.vue"
  import TimeSearch from "@/components/common/TimeSearch.vue"
  import api from "@common/api/index.js"
  import { findDataByParam } from "@/utils/index.js"
  import handleData from "@/utils/handleData.js"
  import NkTable from "@/components/common/NkTable.vue"
  import ResizeContainer from "@/components/common/resizeContainer.vue"
  import echarts from "echarts"
  import dayjs from "dayjs"
  let eleTimeData = [
    {
      type: "day",
      label: "日"
    },
    {
      type: "month",
      label: "月"
    },
    {
      type: "year",
      label: "年"
    }
  ]
  export default {
    components: { TabTree, BtnShow, TimeSearch, NkTable, ResizeContainer },
    data() {
      return {
        tabShow: true,
        viewTreeData: [],
        viewNodeData: [],
        timeData: eleTimeData,
        selectedMeasure: {
          id: "",
          measureName: ""
        },
        selectedDate: {
          startTime: "",
          endTime: ""
        },
        columns: [],
        TypeOfElectricityConsumption: [
          { name: "OfficeElectricity", label: "办公用电" },
          { name: "ElectricityForAirConditioning", label: "空调用电" },
          { name: "LightingElectricity", label: "照明用电" },
          { name: "FireElectricity", label: "消防用电" },
          { name: "SpecialUseOfElectricity", label: "特殊用电" },
          { name: "PowerConsumption", label: "动力用电" },
          { name: "OtherPower", label: "其他用电" }
        ],
        lineCharts: null,
        pieCharts: null,
        tableData: [],
        useEle: "-",
        echartsData: ""
      }
    },
    created() {},
    // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
    mounted() {
      this.drawPie()
    },
    methods: {
      resize() {
        let vm = this
        if (vm.lineCharts) {
          vm.lineCharts.resize()
        }
        if (vm.pieCharts) {
          vm.pieCharts.resize()
        }
      },
      changeCompany(companyId) {
        let vm = this
        api.frontEndPageCustomParam
          .getMyFrontEndPageCustomParam(companyId, "/class/group", null)
          .then(res => {
            const viewTreeData = findDataByParam("viewTree", true, res.data)
            vm.viewTreeData = viewTreeData
          })
      },
      timeControlChange(e) {
        this.selectedDate = e
      },
      TimeControlClick(e) {
        let vm = this
        vm.selectedDate = e
        vm.getData()
      },
      getTreeData(data) {
        let vm = this
        vm.viewNodeData = data
      },
      tabTreeDefault(e) {
        let vm = this
        vm.selectedMeasure = e
        vm.getData()
      },
      tabTreeClick(e) {
        let vm = this
        vm.selectedMeasure = e
        vm.getData()
      },
      async getData() {
        let vm = this
        let viewNodesId = [vm.selectedMeasure.measureId]
        for (let index = 0; index < vm.viewNodeData.length; index++) {
          if (vm.viewNodeData[index].parentId == vm.selectedMeasure.id) {
            viewNodesId.push(vm.viewNodeData[index].measureId)
          }
        }
        let classNameNew = []
        let classNameClass = [] //各种用电量
        let className = []
        let classNameOne = ["总能耗"]
        let classFilterNew = []
        classNameNew.map((item, i) => {
          classFilterNew.push([
            {
              name: item,
              className: "TypeOfElectricityConsumption",
              subclassesName: [classNameClass[i]]
            }
          ])
        })
        vm.columns = [
          { prop: "name", label: "名称", show: true },
          {
            prop: "value",
            label: "电(KWh)",
            show: true
          }
        ]

        const selectedObj = vm.viewNodeData.find(
          it => it.measureId === vm.selectedMeasure.id
        )
        if (!selectedObj) return
        const measures = []
        const pointCode = 100229
        const pointNumber = 0

        let list = [selectedObj]
        const { children, measureId, measureName } = list[0]
        measures.push({ measureId, pointCode, pointNumber })

        if (children.length) {
          children.forEach(item => {
            const { measureId, measureName } = item
            measures.push({ measureId, pointCode, pointNumber })
            classNameOne.push(measureName)
            className.push(measureName)
            list.push(item)
          })
        } else {
          classNameOne.push(measureName)
          className.push(measureName)
        }

        let startTime = vm.selectedDate.startTime
        let endTime = vm.selectedDate.endTime
        let dateType = vm.selectedDate.dateType
        let xData = []
        let apiName = ""
        let apiName2 = ""
        if (dateType == "day") {
          xData = handleData.createXData("0", startTime, endTime, false)
          apiName = "getQuantityHour2"
          apiName2 = "getQuantityDay3"
        } else if (dateType == "month") {
          xData = handleData.createXData("2", startTime, endTime, false)
          apiName = "getQuantityDay3"
          apiName2 = "getQuantityMonth2"
        } else {
          xData = handleData.createXData("5", startTime, endTime, false)
          apiName = "getQuantityMonth2"
          apiName2 = "getQuantityYear2"
        }

        const resArr = await Promise.all([
          api.quantity[apiName](measures, startTime, endTime, 0),
          api.quantity[apiName2](measures, startTime, endTime, 0)
        ])

        let arr =
          resArr[1].data.length &&
          resArr[1].data.find(it => it.measureId === measureId)?.data[0]
        if (!Array.isArray(arr)) arr = [arr]
        vm.useEle = (Array.isArray(arr) ? arr[0] : arr)?.value?.toFixed(2) ?? '-'

        // 曲线图
        let apiData = resArr[0].data

        let line = {
          xAxis: {
            type: "category",
            data: [],
            axisTick: {
              alignWithLabel: false
            }
          },
          series: [],
          legend: []
        }

        for (let i = 0; i < classNameOne.length; i++) {
          line.legend[i] = classNameOne[i]
          let seriesItem = {
            data: [],
            type: i ? "bar" : "line",
            name: classNameOne[i],
            stack: "堆叠"
          }
          let lineItem = apiData.find(
            c => c.measureId == list[i === list.length ? i - 1 : i].measureId
          )

          for (let j = 0; j < xData.length; j++) {
            if (i == 0) {
              line.xAxis.data.push(xData[j].title)
            }
            const dataItem = (Array.isArray(lineItem.data[0]) ? lineItem.data[0] : lineItem.data).find(
              c =>
              handleData.isSameTimeXData(this.selectedDate.dateType, (Array.isArray(c) ? c[0] : c).time, xData[j].title)
            )
            if (dataItem) {
              let val = Array.isArray(dataItem)
                ? dataItem
                : [dataItem.value.toFixed(2)]
              seriesItem.data.push(...val)
            } else {
              seriesItem.data.push("")
            }
          }
          line.series.push(seriesItem)
        }
        //获取分项用电颜色
        const colorArr = className.map(
          it => itemColor.find(k => k.name === it).color
        )

        line.series[0].stack = ""
        let objData = {
          xAxis: {
            type: "category",
            //boundaryGap: false,
            data: line.xAxis.data,
            axisTick: {
              alignWithLabel: false
            }
          },
          series: line.series,
          color: [colorArr[0], ...colorArr],
          legend: {
            right: "12%",
            textStyle: {
              color: "#bcbdbe"
            },
            data: line.legend
          }
        }
        vm.drawLine(objData)
        //饼图
        let apiData2 = resArr[1].data
        let pieItem = apiData2.find(
          c => c.measureId == vm.selectedMeasure.measureId
        )
        let pie = {
          legendData: className,
          seriesData: []
        }
        for (let i = 0; i < className.length; i++) {
          let value = 0
          if (children.length) {
            const item = apiData2.find(
              c => c.measureId == children[i].measureId
            )
            value = item.data[0]?.[0]?.value ?? item.data[0].value
          } else {
            value = pieItem.data[0]?.[0]?.value ?? pieItem.data[0].value
          }
          let seriesItem = {
            value: value?.toFixed(2) || 0,
            name: className[i]
          }
          pie.seriesData.push(seriesItem)
        }
        vm.pieCharts.setOption({
          series: {
            data: pie.seriesData
          },
          color: colorArr
        })
        /* 饼图 */
        let tableData = []
        /* 表格数据 */
        for (let i = 0; i < apiData2.length; i++) {
          const viewNodeItem = vm.viewNodeData.find(
            c => c.measureId == apiData2[i].measureId
          )
          const value =
            apiData2[i].data[0]?.[0]?.value ?? apiData2[i].data[0].value
          if (viewNodeItem) {
            tableData.push({
              name: viewNodeItem.measureName,
              value: value?.toFixed(2) || '-'
            })
          }
        }
        /* 表格数据 */
        vm.tableData = tableData
      },
      drawLine(obj) {
        let vm = this
        vm.lineCharts && vm.lineCharts.dispose()
        vm.lineCharts = vm.$echarts.init(document.getElementById("lineChart"))
        let option = {
          legend: obj.legend,
          xAxis: obj.xAxis,
          grid: {
            x: 66,
            y: 30,
            x2: 20,
            y2: 30
          },
          yAxis: {
            type: "value",
            name: "kWh",
            nameTextStyle: {
              //y轴上方单位的颜色
              color: "#878b97"
            },
            scale: true /*按比例显示*/,
            axisLine: {
              lineStyle: {
                color: "#bcbdbe",
                width: 2
              }
            },
            axisLabel: {
              textStyle: {
                color: "#bcbdbe"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#bcbdbe"],
                width: 1,
                type: "solid"
              }
            }
          },
          label: {},
          tooltip: {
            trigger: "axis",
            confine: true,
            textStyle: {
              align: "left"
            }
          },
          toolbox: {
            feature: {
              saveAsImage: {},
              magicType: {
                type: ["line", "bar"]
              } //切换为折线图，切换为柱状图
            },
            right: "10"
          },
          color: obj.color,
          //   color: [
          //     '#d68818',
          //     '#88a80a',
          //     '#308145',
          //     '#318e96',
          //     '#326293',
          //     '#3d66c1',
          //     '#3a32ab',
          //     '#6325aa',
          //     '#9a1eac',
          //     '#b92626',
          //   ],
          series: obj.series
        }
        this.lineCharts.setOption(option, true)
      },
      drawPie() {
        let vm = this
        this.pieCharts = echarts.init(document.getElementById("pieChart"))
        let option = {
          title: {
            text: "",
            subtext: "",
            left: "center",
            show: true
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}<br/> {c} ({d}%)"
          },
          graphic: {
            type: "text",
            left: "center",
            top: "50%",
            style: {
              text: "分项用能",
              textAlign: "center",
              fill: "#333",
              fontSize: 20,
              fontWeight: 700
            }
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["40%", "70%"],
              data: [],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              },
              label: {
                formatter: function(params) {
                  let pieName = params.name.split("/").join(" ")
                  let num = params.value
                  let percent = params.percent
                  return percent + "%" + "\n" + pieName + "\n" + num + "kWh"
                },
                color: "#000",
                fontWeight: "bolder"
              }
            }
          ]
        }

        this.pieCharts.setOption(option)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .group-wrap {
    padding: 14px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    box-sizing: border-box;
  }
  .tree-content {
    //   width: 260px;
    min-width: 200px;
    margin-right: 14px;
  }
  .content {
    width: 100%;
    //   width: calc(100% - 274px);
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    background: transparent;
  }
  .search-box {
    height: 40px;
  }
  .chart-content {
    margin-top: 14px;
    width: 100%;
  }
  .chart-box {
    width: 100%;
    height: 400px;
    border-radius: 4px;
    background: #ffffff;
    flex-flow: column;
    position: relative;
    .title {
      height: 30px;
      line-height: 30px;
      padding: 0px 10px;
      color: #000;
      text-align: left;
      font-weight: bold;
    }
    .chart {
      width: 100%;
      height: calc(100% - 30px);
      padding: 10px;
      box-sizing: border-box;
    }
  }
  .table-content {
    margin-top: 14px;
    height: 320px;
  }
  .useTop {
    padding: 10px;
    background: red;
    position: absolute;
    border-radius: 4px;
    color: #fff;
    box-sizing: border-box;
    left: 12%;
    top: 8px;
  }
</style>
